const style = {
  imageStyle: (width, height) => ({
    width: `${width}px`,
    height: `${height}px`,
    pointerEvents: 'none',
    userSelect: 'none',
    opacity: 0,
    transition: 'opacity 1s',
  }),
  imageLoaded: {
    opacity: 1,
  },
};
export default style;



// WEBPACK FOOTER //
// ./src/components/Map/MapImage/MapImage.styles.js